import { render, staticRenderFns } from "./userCustomers.vue?vue&type=template&id=524ba702"
import script from "./userCustomers.vue?vue&type=script&lang=js"
export * from "./userCustomers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports